import { PatientMergeHistoryListService } from './../core/service/grid-data/grid-data-patient-merge-history.service';
import { PinnedResourceModule } from './../pinned-resource/pinned-resource.module';
import { ClinicalRecordModule } from './../clinical-record/clinical-record.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberModule } from '../member/member.module';
import { MemberSearchModule } from 'src/app/shared/member-search/member-search.module';
import { PatientSummaryComponent } from './patient-summary/patient-summary.component';
import { FlagModule } from '../flag/flag.module';
import { TaskModule } from '../task/task.module';
import { SharedModule } from '../shared/shared.module';
import { DocumentModule } from '../document/document.module';
import { ProgramModule } from '../program/program.module';
import { ContactHistoryModule } from '../contact-history/contact-history.module';
import { MessageModule } from '../message/message.module';
import { NotesModule } from '../notes/notes.module';
import { InsuranceModule } from '../insurance/insurance.module';
import { TeamModule } from '../team/team.module';
import { EventModule } from '../event/event.module';
import { PatientHistoryComponent } from './patient-history/patient-history.component';
import { AppointmentModule } from '../appointment/appointment.module';
import { PatientSummaryChartComponent } from './patient-summary/patient-summary-chart/patient-summary-chart.component';
import { PatientSummaryChartWellBeingComponent }
  from './patient-summary/patient-summary-chart/patient-summary-chart-well-being/patient-summary-chart-well-being.component';
import { CaseModule } from '../case/case.module';
import { ReferralModule } from '../referral/referral.module';
import { MemberAssessmentModule } from '../shared/member-assessment/member-assessment.module';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { GoalModule } from '../goal/goal.module';
import { AuditMemberModule } from '../audit/audit-member/audit-member.module';
import { PatientAccumulatorModule } from './patient-accumulator/patient-accumulator.module';

@NgModule({
  declarations: [
    PatientSummaryComponent,
    PatientHistoryComponent,
    PatientSummaryChartComponent,
    PatientSummaryChartWellBeingComponent
  ],
  imports: [
    CommonModule,
    MemberModule,
    MemberSearchModule,
    FlagModule,
    TaskModule,
    SharedModule,
    DocumentModule,
    ProgramModule,
    ContactHistoryModule,
    MessageModule,
    NotesModule,
    InsuranceModule,
    TeamModule,
    EventModule,
    AppointmentModule,
    ClinicalRecordModule,
    CaseModule,
    PinnedResourceModule,
    ReferralModule,
    MemberAssessmentModule,
    InfiniteScrollDirective,
    GoalModule,
    AuditMemberModule,
    PatientAccumulatorModule
  ],
  exports: [
    PatientSummaryComponent
  ],
  providers: [
    PatientMergeHistoryListService
  ]
})
export class PatientModule { }
